// extracted by mini-css-extract-plugin
export var blue = "_1k-g";
export var brand = "_1k-c";
export var darkGrey = "_1k-f";
export var disabled = "_1k-6";
export var disabledSubtle = "_1k-7";
export var error = "_1k-8";
export var green = "_1k-h";
export var grey = "_1k-e";
export var icon = "_1k-0";
export var inherit = "_1k-b";
export var lightGrey = "_1k-d";
export var orange = "_1k-j";
export var pink = "_1k-l";
export var primary = "_1k-1";
export var purple = "_1k-m";
export var quaternary = "_1k-4";
export var quinary = "_1k-5";
export var red = "_1k-k";
export var secondary = "_1k-2";
export var success = "_1k-a";
export var tertiary = "_1k-3";
export var warning = "_1k-9";
export var white = "_1k-n";
export var yellow = "_1k-i";